import type { IAccountNotifications } from './AccountNotifications.interface';
import AccountNotificationsDeals from './AccountNotificationsDeals';
import AccountNotificationsTasks from './AccountNotificationsTasks';
import AccountNotificationsNotes from './AccountNotificationsNotes';
import AccountNotificationsFiles from './AccountNotificationsFiles';
import AccountNotificationsClientPortal from './AccountNotificationsClientPortal';
import AccountNotificationsPartnerPortal from './AccountNotificationsPartnerPortal';

export default class AccountNotifications implements IAccountNotifications {
  deals: AccountNotificationsDeals;
  tasks: AccountNotificationsTasks;
  notes: AccountNotificationsNotes;
  files: AccountNotificationsFiles;
  clientPortal: AccountNotificationsClientPortal;
  partnerPortal: AccountNotificationsPartnerPortal;

  static build = (data: IAccountNotifications) => new AccountNotifications(data);
  static blank = () => new AccountNotifications();

  /**
   * Constructor
   * @param {IAccountNotifications} data
   */
  constructor(data?: IAccountNotifications) {
    this.deals = new AccountNotificationsDeals(data?.deals);
    this.tasks = new AccountNotificationsTasks(data?.tasks);
    this.notes = new AccountNotificationsNotes(data?.notes);
    this.files = new AccountNotificationsFiles(data?.files);
    this.clientPortal = new AccountNotificationsClientPortal(data?.clientPortal);
    this.partnerPortal = new AccountNotificationsPartnerPortal(data?.partnerPortal);
  }
}
